var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      width: "1000px",
      title: _vm.$t("public.importfiledproduct"),
      visible: _vm.visible,
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      cancel: _vm.cancelmodal
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "20px",
      "padding-bottom": "16px"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("public.success")) + "：" + _vm._s(_vm.importObj.successNum) + _vm._s(_vm.$t("public.individual")))]), _c("span", {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.fail")) + "：" + _vm._s(_vm.importObj.failNum) + _vm._s(_vm.$t("public.individual")))])]), _c("a-table", {
    attrs: {
      pagination: false,
      rowKey: "goodsNo",
      columns: _vm.modelcolumns,
      "data-source": _vm.importObj.failList
    },
    scopedSlots: _vm._u([{
      key: "goodsname",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(text))])], 2), _c("br"), record.specName != "" ? _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.specName) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(record.specName))])], 2) : _vm._e()], 1);
      }
    }, {
      key: "pricetax",
      fn: function fn(text, record) {
        return _c("span", {}, [record.productStatus != 4 ? _c("span", [_vm._v(" " + _vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(text)) + _vm._s(_vm.rightCurrencySymbol) + " ")]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "product-stocknum",
      fn: function fn(text, record) {
        return _c("span", {}, [record.productStatus != 4 ? _c("span", [_vm._v(" " + _vm._s(text) + " ")]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "statename",
      fn: function fn(text, record) {
        return _c("span", {}, [text == 0 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("public.notontheshelf")) + " ")]) : _vm._e(), text == 2 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("public.deleted")) + " ")]) : _vm._e(), text == 3 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("public.disposals")) + " ")]) : _vm._e(), text == 4 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("public.nonexistent")) + " ")]) : _vm._e()], 1);
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "goodsnametitle"
    },
    slot: "goodsnametitle"
  }, [_vm._v(_vm._s(_vm.$t("publicuse.goodsname")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "exclamation-circle",
      rotate: 180
    }
  })], 2)], 1)]), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };